import React from 'react';

const Odometer = ({ percentage, label = "Placement Rate" }) => {
  const needleRotation = (percentage / 100) * 180 - 90;
  
  const getColor = () => {
    if (percentage < 40) return '#dc3545';
    if (percentage < 70) return '#ff9800';
    return '#28a745';
  };

  return (
    <div className="odometer-card">
      <div className="stat-label">{label}</div>
      <div className="odometer-container">
        <svg className="odometer-arc" viewBox="0 0 200 120">
          <defs>
            <linearGradient
              id="arcGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
            >
              <stop
                offset="0%"
                style={{ stopColor: '#dc3545', stopOpacity: 1 }}
              />
              <stop
                offset="50%"
                style={{ stopColor: '#ffc107', stopOpacity: 1 }}
              />
              <stop
                offset="100%"
                style={{ stopColor: '#28a745', stopOpacity: 1 }}
              />
            </linearGradient>
          </defs>
          <path
            d="M 20 100 A 80 80 0 0 1 180 100"
            fill="none"
            stroke="url(#arcGradient)"
            strokeWidth="15"
            strokeLinecap="round"
          />
        </svg>
        <div
          className="odometer-needle"
          style={{ transform: `translateX(-50%) rotate(${needleRotation}deg)` }}
        ></div>
        <div className="odometer-center"></div>
      </div>
      <div className="odometer-value" style={{ color: getColor() }}>
        {percentage?.toFixed(2)}%
      </div>
    </div>
  );
};

export default Odometer;
